import { render, staticRenderFns } from "./printerRuleDiv.vue?vue&type=template&id=883b0138&scoped=true"
import script from "./printerRuleDiv.vue?vue&type=script&lang=js"
export * from "./printerRuleDiv.vue?vue&type=script&lang=js"
import style0 from "./printerRuleDiv.vue?vue&type=style&index=0&id=883b0138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883b0138",
  null
  
)

export default component.exports